import React from "react";

// EmptyValue — the "no data here" mark, visually distinct from real content.
//
// Every empty cell across the console used a bare "—" string, which inherits the cell's
// ambient text colour (black) — indistinguishable at a glance from an actual
// one-character value. In a table where most of a row is real data and a few cells are
// empty, that means scanning for "what's missing" requires reading every character
// rather than just looking for the lighter marks.
//
// `text-gray-400 text-sm` is byte-identical to the legacy order table's own placeholder
// mark (src/components/orderTable/helpers.js:111,146 — same span, same em dash), so an
// empty cell reads the same here as it does on /all-orders.
//
// Deliberately not italic: STALE/NO_DATA on the TAT dashboard already use italic to
// mean something specific (a real, still-open gap in tracked data) — reusing it here
// for "this field is simply blank" would blur that distinction.
function EmptyValue() {
    return <span className="text-gray-400 text-sm">—</span>;
}

export default EmptyValue;
